export const attributeModel = {
    name: "",
    description: "",
};
